const translations = {
    es: {
        // Cabeceras de tabla
        "table.header.uuid": "UUID",
        "table.header.model": "Modelo",
        "table.header.config": "Configuración",
        "table.header.send": "Enviar",
        "table.header.server": "Servidor",
        "table.header.network": "Red",
        "table.header.confirmations": "Confirmaciones",
        "table.header.date": "Fecha",
        "table.header.updated": "Actualizado",
        "table.header.status": "Estado",
        "table.header.actual": "Actual",
        "table.header.queue": "Cola",
        "table.header.params": "Parametros",
        // Tipos de envíos
        "send.type.measurement": "Medición",
        "send.type.sensors": "Sensores",
        "send.type.alerts": "Alarmas",

        // Confirmaciones
        "confirm.sent": "Enviado",
        "confirm.confirmed": "Confirmado",
        "confirm.sent.short": "E",
        "confirm.confirmed.short": "C",

        // Botones
        "button.edit": "Editar",
        "button.send": "Enviar",
        "button.cancel": "Cancelar",
        "button.accept": "Aceptar",

        // Estados
        "status.pending": "Pendiente",
        "status.sent": "Enviado",
        "status.confirmed": "Confirmado",
        "status.error": "Error",

        // Filtros
        "filter.search": "Buscar",
        "filter.search.placeholder": "uuid, uid, dirección",
        "filter.select.option": "Seleccionar a filtrar",
        "filter.select.status": "Seleccionar Estado",
        "filter.select.device_group": "Seleccionar Grupo de dispositivo",
        "filter.select.asset_group": "Seleccionar contenedores",
        "filter.select.island": "Seleccionar Isla",
        "filter.select.model": "Seleccionar Modelo",
        "filter.select.config": "Seleccionar Configuración",

        "filter.label.status": "Estado",
        "filter.label.device_group": "Grupo dispositivo",
        "filter.label.asset_group": "Grupo contenedor",
        "filter.label.island": "Isla",
        "filter.label.model": "Modelo",
        "filter.label.config": "Configuración",

        // Otros
        "no.data": "Sin datos",

        // Formulario
        "form.title.select.config": "Seleccionar configuración",
        "label.uuid": "UUID",
        "label.send": "Enviar",
        "label.profile.group": "Grupo de perfil",
        "option.select.config": "Seleccionar configuración",
        "label.model": "Modelo",
        "label.name": "Nombre",
        "label.description": "Descripción",
        // - SERVER
        "label.network": "Red",
        "label.pin": "PIN",
        "label.band": "Banda",
        "label.apn_name": "Nombre APN",
        "label.apn_user": "Usuario APN",
        "label.apn_pass": "Contraseña APN",
        "label.preference_sim": "Preferencia SIM",
        "label.sim0_band": "Banda SIM 0",
        "label.sim0_pin": "PIN SIM 0",
        "label.sim0_apn_name": "Nombre APN SIM 0",
        "label.sim0_apn_user": "Usuario APN SIM 0",
        "label.sim0_apn_pass": "Contraseña APN SIM 0",
        "label.sim1_band": "Banda SIM 1",
        "label.sim1_pin": "PIN SIM 1",
        "label.sim1_apn_name": "Nombre APN SIM 1",
        "label.sim1_apn_user": "Usuario APN SIM 1",
        "label.sim1_apn_pass": "Contraseña APN SIM 1",
        // MQTT
        "label.ip": "IP",
        "label.port": "Puerto",
        "label.user": "Usuario",
        "label.pass": "Contraseña",
        "label.client": "Cliente",
        "label.protocol": "Protocolo",
        "label.topic_data": "Topic de mediciones TX",
        "label.topic_alerts": "Topic de alertas TX",
        "label.topic_control": "Topic de control RX",
        "label.topic_admin": "Topic de admin RX",
        // NTP
        "label.url_1": "URL 1",
        "label.url_2": "URL 2",
        "label.url_3": "URL 3",
        "label.url_4": "URL 4",
        // GPS
        "label.time": "Minutos",
        "label.days": "Días",
        // Params
        "label.battery": "Batería",
        "label.hibernate": "Hibernar",
        "label.reset_default": "Valores por defecto",
        "label.info": "Información",
        "label.infoCD": "Información CD",
        "label.infoCE": "Información CE",
        "label.presets_dd": "Presets DD",

        // Question
        "question.title": "Cola ocupada.",
        "question.text": "¿Desea vaciarla al enviar la nueva configuración?",
        "question.all.title": "Colas ocupadas: ",
        "question.all.text": "¿Desea vaciarlas y enviar las nuevas configuraciones?",
        "question.send.title": "Número de dispositivos para enviar la nueva configuración: ",
        "question.send.text": "¿Desea continuar?",

        // Mensajes adicionales
        "message.success.title": "Solicitud",
        "message.success.text": "Se han encolado las configuraciones para su envio.",
        "message.success.saved": "Se han guardado las configuraciones.",
        "message.error.models": "Solo puede seleccionarse un modelo por comando.",

        // Botones
        "button.save": "Guardar",
    },
    en: {
        // Table headers
        "table.header.uuid": "UUID",
        "table.header.model": "Model",
        "table.header.config": "Configuration",
        "table.header.send": "Send",
        "table.header.server": "Server",
        "table.header.network": "Network",
        "table.header.confirmations": "Confirmations",
        "table.header.date": "Date",
        "table.header.updated": "Updated",
        "table.header.status": "Status",
        "table.header.actual": "Actual",
        "table.header.queue": "Queue",
        "table.header.params": "Parameters",

        // Confirmations
        "confirm.sent": "Sent",
        "confirm.confirmed": "Confirmed",
        "confirm.sent.short": "S",
        "confirm.confirmed.short": "C",

        // Buttons
        "button.edit": "Edit",
        "button.send": "Send",
        "button.cancel": "Cancel",
        "button.accept": "Accept",

        // Statuses
        "status.pending": "Pending",
        "status.sent": "Sent",
        "status.confirmed": "Confirmed",
        "status.error": "Error",

        // Messages
        "message.success.title": "Successful operation",
        "message.success.sent": "Configuration sent successfully",
        "message.success.saved": "Configurations saved successfully",
        "message.error.title": "Error in sending",
        "message.error.text": "The configuration could not be sent",
        "message.confirm.title": "Confirm sending",
        "message.confirm.text": "Are you sure to send the configuration to the selected devices?",
        "message.error.models": "Only one model can be selected per command.",

        // Filters
        "filter.search": "Search",
        "filter.search.placeholder": "uuid, uid, address",
        "filter.select.option": "Select to filter",
        "filter.select.status": "Select Status",
        "filter.select.device_group": "Select Device Group",
        "filter.select.asset_group": "Select Container Group",
        "filter.select.island": "Select Island",
        "filter.select.model": "Select Model",
        "filter.select.config": "Select Configuration",

        "filter.label.status": "Status",
        "filter.label.device_group": "Device Group",
        "filter.label.asset_group": "Container Group",
        "filter.label.island": "Island",
        "filter.label.model": "Model",
        "filter.label.config": "Configuration",

        // Others
        "no.data": "No data",

        // Form
        "form.title.select.config": "Select configuration",
        "label.uuid": "UUID",
        "label.send": "Enviar",
        "label.profile.group": "Profile Group",
        "option.select.config": "Select configuration",
        "label.model": "Model",
        "label.name": "Name",
        "label.description": "Description",
        // - SERVER
        "label.network": "Red",
        "label.pin": "PIN",
        "label.band": "Band",
        "label.apn_name": "APN Name",
        "label.apn_user": "APN User",
        "label.apn_pass": "APN Password",

        // MQTT
        "label.ip": "IP",
        "label.port": "Port",
        "label.user": "User",
        "label.pass": "Password",
        "label.client": "Client",
        "label.protocol": "Protocol",
        "label.topic_data": "Topic TX Measurements",
        "label.topic_alerts": "Topic TX Alerts",
        "label.topic_control": "Topic RX Control",
        "label.topic_admin": "Topic RX Admin",
        // NTP
        "label.url_1": "URL 1",
        "label.url_2": "URL 2",
        "label.url_3": "URL 3",
        "label.url_4": "URL 4",
        // GPS
        "label.time": "Minutes",
        "label.days": "Days",
        // Params
        "label.battery": "Battery",
        "label.hibernate": "Hibernate",
        "label.reset_default": "Reset default values",
        "label.info": "Info",
        // Question
        "question.title": "Queue is occupied, UUID: ",
        "question.text": "Do you want to clear the queue when sending the new configuration?",
        "question.all.title": "Occupied queues: ",
        "question.all.text": "Do you want to clear the queues when sending the new configurations?",
        "question.send.title": "Number of devices to send the new configuration: ",
        "question.send.text": "Do you want to continue?",

        // Additional messages

        // Buttons
        "button.save": "Save",
    },
};

export default translations;
